/** Id de la rangée Email dans l’arbre Documents — jamais un uuid de `dossier_folders`. */
export const VIRTUAL_EMAIL_ID = '__email__';

export const VIRTUAL_EMAIL_LABEL = 'Email';

/** Query `?email=1` : déplie la rangée Email (notifs, ancien onglet Correspondance). */
export const VIRTUAL_EMAIL_QUERY = 'email';

export function documentsTabUrl(dossierId: string, openEmail = false): string {
  const base = `/dossiers/${dossierId}/documents`;
  if (!openEmail) return base;
  return `${base}?${VIRTUAL_EMAIL_QUERY}=1`;
}

export function shouldOpenVirtualEmail(search: string): boolean {
  const raw = search.startsWith('?') ? search.slice(1) : search;
  return new URLSearchParams(raw).get(VIRTUAL_EMAIL_QUERY) === '1';
}
